import { render, staticRenderFns } from "./SubTitulo.vue?vue&type=template&id=fc5aa796&scoped=true&"
import script from "./SubTitulo.vue?vue&type=script&lang=js&"
export * from "./SubTitulo.vue?vue&type=script&lang=js&"
import style0 from "./SubTitulo.vue?vue&type=style&index=0&id=fc5aa796&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5aa796",
  null
  
)

export default component.exports